import { LitElement, html, css } from 'lit';

class ToastNotification extends LitElement {
  static properties = {
    _toasts: { state: true },
  };

  static styles = css`
    :host { position: fixed; top: 1rem; right: 1rem; z-index: 100; display: flex; flex-direction: column; gap: 0.5rem; }
    .toast { padding: 0.75rem 1.5rem; border-radius: 0.5rem; color: white; font-size: 0.875rem; box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1); animation: slideIn 0.3s ease-out; max-width: 24rem; }
    .toast.success { background: #16A34A; }
    .toast.error { background: #DC2626; }
    .toast.fade-out { animation: slideOut 0.3s ease-in forwards; }
    @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
    @keyframes slideOut { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0; } }
  `;

  constructor() {
    super();
    this._toasts = [];
    this._id = 0;
  }

  connectedCallback() {
    super.connectedCallback();
    this._onSuccess = (e) => this.show(e.detail.message, 'success');
    this._onError = (e) => this.show(e.detail.message, 'error');
    window.addEventListener('toast-success', this._onSuccess);
    window.addEventListener('toast-error', this._onError);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('toast-success', this._onSuccess);
    window.removeEventListener('toast-error', this._onError);
  }

  show(message, type = 'success') {
    const id = ++this._id;
    this._toasts = [...this._toasts, { id, message, type }];
    const duration = type === 'error' ? 5000 : 3000;
    setTimeout(() => this.dismiss(id), duration);
  }

  dismiss(id) {
    this._toasts = this._toasts.filter((t) => t.id !== id);
  }

  render() {
    return html`${this._toasts.map((t) => html`
      <div class="toast ${t.type}">${t.message}</div>
    `)}`;
  }
}

customElements.define('toast-notification', ToastNotification);

// Helper functions for dispatching toast events
export function showSuccess(message) {
  window.dispatchEvent(new CustomEvent('toast-success', { detail: { message } }));
}

export function showError(message) {
  window.dispatchEvent(new CustomEvent('toast-error', { detail: { message } }));
}
